import { reduxForm } from 'redux-form';

import { FormData } from 'components/MyWaitrose/Form';
import LinkMyWaitroseCard, {
  LinkMyWaitroseCardProps,
} from 'components/MyWaitrose/LinkMyWaitroseCard/LinkMyWaitroseCard';

export default reduxForm<FormData, LinkMyWaitroseCardProps>({
  form: 'Forms.MyWaitrose.EnterMyWaitroseNumber',
})(LinkMyWaitroseCard);
